import React from 'react';

export default function Icon({ name, size = 22, stroke = 'currentColor', sw = 1.5, style }) {
  const props = {
    width: size,
    height: size,
    viewBox: '0 0 24 24',
    fill: 'none',
    stroke,
    strokeWidth: sw,
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
    style,
  };
  switch (name) {
    case 'arrow-right':
      return (<svg {...props}><path d="M5 12h14M13 5l7 7-7 7"/></svg>);
    case 'arrow-up-right':
      return (<svg {...props}><path d="M7 17 17 7M8 7h9v9"/></svg>);
    case 'arrow-left':
      return (<svg {...props}><path d="M19 12H5M11 5l-7 7 7 7"/></svg>);
    case 'menu':
      return (<svg {...props}><path d="M3 7h18M3 17h18"/></svg>);
    case 'close':
      return (<svg {...props}><path d="M6 6l12 12M6 18 18 6"/></svg>);
    case 'phone':
      return (<svg {...props}><path d="M5 4h4l2 5-2.5 1.5a11 11 0 0 0 5 5L15 13l5 2v4a2 2 0 0 1-2 2A16 16 0 0 1 3 6a2 2 0 0 1 2-2z"/></svg>);
    case 'mail':
      return (<svg {...props}><rect x="3" y="5" width="18" height="14" rx="2"/><path d="m3 7 9 6 9-6"/></svg>);
    case 'whatsapp':
      return (
        <svg viewBox="0 0 24 24" width={size} height={size} fill={stroke} style={style}>
          <path d="M17.6 14.2c-.3-.1-1.7-.8-2-.9-.3-.1-.5-.1-.6.1-.2.3-.7.9-.9 1.1-.2.1-.3.2-.6 0-.3-.1-1.2-.4-2.3-1.4-.9-.8-1.5-1.7-1.6-2-.2-.3 0-.4.1-.6.1-.1.3-.3.4-.5.1-.1.2-.3.3-.4.1-.2 0-.4 0-.5l-.8-2c-.2-.5-.4-.4-.6-.4h-.5c-.2 0-.4.1-.7.3-.3.3-1 1-1 2.4s1 2.8 1.2 3c.1.2 2.1 3.3 5.1 4.6.7.3 1.3.5 1.7.6.7.2 1.4.2 1.9.1.6-.1 1.7-.7 2-1.4.3-.7.3-1.3.2-1.4-.1-.2-.3-.2-.5-.4zM12 2C6.5 2 2 6.5 2 12c0 1.7.4 3.4 1.3 4.8L2 22l5.4-1.3C8.7 21.6 10.3 22 12 22c5.5 0 10-4.5 10-10S17.5 2 12 2z"/>
        </svg>
      );
    case 'calendar':
      return (<svg {...props}><rect x="3" y="5" width="18" height="16" rx="2"/><path d="M3 9h18M8 3v4M16 3v4"/></svg>);
    case 'clock':
      return (<svg {...props}><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/></svg>);
    case 'home':
      return (<svg {...props}><path d="M3 11 12 4l9 7v9a1 1 0 0 1-1 1h-5v-6h-6v6H4a1 1 0 0 1-1-1z"/></svg>);
    case 'pin':
      return (<svg {...props}><path d="M12 22s7-7 7-12a7 7 0 1 0-14 0c0 5 7 12 7 12z"/><circle cx="12" cy="10" r="2.5"/></svg>);
    case 'check':
      return (<svg {...props}><path d="m4 12 5 5 11-11"/></svg>);
    case 'plus':
      return (<svg {...props}><path d="M12 5v14M5 12h14"/></svg>);
    case 'minus':
      return (<svg {...props}><path d="M5 12h14"/></svg>);
    case 'star':
      return (<svg {...props}><path d="m12 3 2.7 6 6.3.6-4.7 4.4 1.4 6.4L12 17l-5.7 3.4 1.4-6.4L3 9.6 9.3 9z"/></svg>);
    case 'play':
      return (<svg {...props}><path d="M7 5v14l12-7z"/></svg>);
    case 'spine':
      return (
        <svg {...props}>
          <path d="M12 3c2 1 3 2 3 4s-3 1-3 3 3 1 3 3-3 1-3 3 3 1 3 3-1 2-3 3"/>
          <path d="M12 3c-2 1-3 2-3 4s3 1 3 3-3 1-3 3 3 1 3 3-3 1-3 3 1 2 3 3"/>
        </svg>
      );
    case 'brain':
      return (
        <svg {...props}>
          <path d="M9 4a3 3 0 0 0-3 3v1a3 3 0 0 0-2 3 3 3 0 0 0 1 2.2A3 3 0 0 0 7 20a3 3 0 0 0 3-2"/>
          <path d="M15 4a3 3 0 0 1 3 3v1a3 3 0 0 1 2 3 3 3 0 0 1-1 2.2A3 3 0 0 1 17 20a3 3 0 0 1-3-2"/>
          <path d="M10 4a2 2 0 0 1 4 0v14"/>
        </svg>
      );
    case 'baby':
      return (
        <svg {...props}>
          <circle cx="12" cy="7" r="3"/>
          <path d="M5 21c0-3 3-6 7-6s7 3 7 6"/>
          <path d="M9 7h.01M15 7h.01"/>
        </svg>
      );
    case 'cane':
      return (
        <svg {...props}>
          <path d="M9 4h3a3 3 0 0 1 3 3v0a3 3 0 0 1-3 3H9"/>
          <path d="M9 4v18"/>
        </svg>
      );
    case 'bandage':
      return (
        <svg {...props}>
          <rect x="3" y="9" width="18" height="6" rx="3" transform="rotate(-30 12 12)"/>
          <path d="M9 12h.01M12 9h.01M12 15h.01M15 12h.01"/>
        </svg>
      );
    case 'instagram':
      return (
        <svg {...props}>
          <rect x="3" y="3" width="18" height="18" rx="5"/>
          <circle cx="12" cy="12" r="4"/>
          <circle cx="17" cy="7" r="0.7" fill={stroke}/>
        </svg>
      );
    case 'quote':
      return (
        <svg viewBox="0 0 24 24" width={size} height={size} fill={stroke} style={style}>
          <path d="M7 7h4v4H8c0 2 1 3 3 3v3c-4 0-6-2-6-6V7zm9 0h4v4h-3c0 2 1 3 3 3v3c-4 0-6-2-6-6V7z"/>
        </svg>
      );
    default:
      return null;
  }
}
